import {
  earnOneThousandGetYourLink,
  copyLinkClipboard,
  shareFacebook,
  sendEmailEvent,
} from '../segment'
;(function module() {
  angular.module('app.ui.form.ctrls').controller('InviteFriendController', [
    '$log',
    '$scope',
    '$location',
    '$anchorScroll',
    'logger',
    'InviteFriendApi',
    function controller(
      $log,
      $scope,
      $location,
      $anchorScroll,
      logger,
      InviteFriendApi
    ) {
      let friendNameAndEmail
      let vm = this
      vm.user = {firstName: '', lastName: '', email: ''}
      vm.pattern = /^[A-Za-z]+[\w+.]+@[.A-Za-z-]+\.[.A-Za-z]{2,5}$/
      vm.textToCopy = angular.element('.refer-message').text()
      vm.editorOptions = {
        extraPlugins: 'colorbutton',
      }

      vm.referralCode = ''
      vm.friendsList = []
      friendNameAndEmail = {
        name: '',
        email: '',
      }
      vm.friendsList.push(friendNameAndEmail)
      vm.hideDropDown = () => {
        vm.showClass = ''
      }

      vm.showClass = ''
      vm.showDropDown = () => {
        if (vm.showClass === '') {
          vm.showClass = 'show'
        } else {
          vm.showClass = ''
        }
      }

      vm.copySuccess = () => {
        copyLinkClipboard()
        logger.notify('success', 'Link successfully copied to clipboard')
      }

      vm.showEmailInvalid = false
      vm.validateEmail = event => {
        const index = event.target.attributes.class.value.search(' ng-invalid ')
        if (index >= 0) {
          vm.showEmailInvalid = true
        } else {
          vm.showEmailInvalid = false
        }
      }

      vm.showClass = ''
      vm.copyFail = error => {
        logger.notify('error', 'Unable to copy.')
        $log.info(error)
      }

      vm.hideDropDown = () => {
        vm.showClass = ''
      }

      vm.showDropDown = () => {
        if (vm.showClass === '') {
          vm.showClass = 'show'
        } else {
          vm.showClass = ''
        }
      }

      vm.populateCode = data => {
        vm.referralCode = data
        const lexstepReferUrl = `${process.env.PUBLIC_URL}/sign-up/${vm.referralCode}`
        const encodedReferUrl = encodeURIComponent(lexstepReferUrl)
        vm.shareLink =
          'https://www.facebook.com/sharer/sharer.php?u=' +
          encodedReferUrl +
          '&amp;src=sdkpreparse'
        vm.dataLink = lexstepReferUrl
        vm.textToCopy = lexstepReferUrl
        vm.referEmail.subject =
          'Invitation from your friend ' +
          vm.user.firstName +
          ' ' +
          vm.user.lastName
        $scope.$apply()
      }

      vm.changeStatus = status => {
        if (status === 404) {
          vm.alertMsg = 'Error! Passwords do not match. Please try again.'
          vm.showOnError = true
        } else if (status === 400) {
          vm.alertMsg = 'Error! Emails do not match. Please try again.'
          vm.showOnError = true
        } else if (status === 409) {
          vm.alertMsg = 'Error! Email already in use. Please use another email.'
          vm.showOnError = true
        } else if (status === 500) {
          vm.alertMsg =
            'Could not connect to the server. Please try again later.'
          vm.showOnError = true
        } else {
          vm.alertMsg = 'An error has occurred. Please try the action again.'
          vm.showOnError = true
        }
      }

      vm.showCode = false
      vm.jumpToLink = () => {
        const oldHash = $location.hash()
        $location.hash('referralLink')
        $anchorScroll()
        $location.hash(oldHash)
      }

      vm.getEmailText = async refer => {
        const {data, status} = await InviteFriendApi.getInviteFriendsEmail()

        if (status === 440) $location.url('/signin')
        vm.referEmail.emailText = stringReplaceAll(
          data.versions[0].html_content,
          '<%-referralCode%>',
          `${process.env.PUBLIC_URL}/sign-up/${refer}`
        )
        vm.referEmail.emailText = stringReplaceAll(
          vm.referEmail.emailText,
          '{{publicURL}}',
          process.env.PUBLIC_URL
        )

        vm.referEmail.emailText = stringReplaceAll(
          vm.referEmail.emailText,
          '{{referredPerson.name}}',
          '[name]'
        )

        vm.referEmail.emailText = stringReplaceAll(
          vm.referEmail.emailText,
          '{{user.firstName}}',
          vm.user.firstName
        )
        vm.referEmail.emailText = stringReplaceAll(
          vm.referEmail.emailText,
          '{{ user.lastName}}',
          vm.user.lastName
        )
        vm.referEmail.emailText = stringReplaceAll(
          vm.referEmail.emailText,
          '{{user.referralCode}}',
          vm.referralCode
        )
        $scope.$apply()
      }

      vm.referEmail = {
        friendsName: [],
        friendsEmail: [],
        subject: '',
        frCount: 0,
        emailText: '',
        friends: [],
      }
      vm.isFriendsListFilled = () => {
        let friendsListSize
        let index
        let k
        let reference
        friendsListSize = vm.friendsList.length
        for (
          index = 0, k = 0, reference = friendsListSize;
          reference >= 0 ? k < reference : k > reference;
          index = reference >= 0 ? ++k : --k
        ) {
          if (!vm.friendsList[index].email) {
            return false
          }
        }

        return true
      }

      vm.sendReferEmail = async () => {
        vm.referEmail.friends = vm.friendsList
        vm.referEmail.emailText = vm.referEmail.emailText.replace(
          '[yourFirstName]',
          vm.user.firstName
        )
        vm.referEmail.emailText = vm.referEmail.emailText.replace(
          '[yourLastName]',
          vm.user.lastName
        )

        const {status} = await InviteFriendApi.sendReferralEmails(
          vm.user.id,
          vm.friendsList,
          true
        )

        if (status !== 201)
          return logger.notify(
            'error',
            'There has been an error in sending your emails. Please try again'
          )
        if (status === 201) {
          return logger.notify(
            'success',
            'Email(s) have been sent successfully.'
          )
        }

        sendEmailEvent()
      }

      vm.anotherFriend = () => {
        friendNameAndEmail = {
          name: '',
          email: '',
        }
        if (vm.friendsList.length < 5) {
          vm.friendsList.push(friendNameAndEmail)
        }
      }

      vm.removeFriend = removedFriend => {
        const itemToBeRemovedIndex = vm.friendsList.indexOf(removedFriend)
        vm.friendsList.splice(itemToBeRemovedIndex, 1)
      }

      vm.addUser = async () => {
        vm.showOnError = false
        const externalUserResponse = await InviteFriendApi.createExternalUser(
          vm.user
        )

        if (externalUserResponse.status === 201) {
          const externalUser = externalUserResponse.data
          vm.referralCode = `e${externalUser.id}`
          vm.getEmailText(vm.referralCode)
          earnOneThousandGetYourLink(
            externalUser.firstName,
            externalUser.lastName,
            externalUser.email
          )
          vm.user.id = externalUser.id
          vm.showCode = true
          vm.showOnError = false
          vm.jumpToLink()
          vm.linkOnly = 'col-md-offset-1 col-md-10'
          vm.populateCode(vm.referralCode)

          $scope.$applyAsync()
        } else vm.changeStatus(externalUserResponse.status)
      }

      vm.onClickShareFacebook = () => {
        shareFacebook()
      }
    },
  ])
})()

const stringReplaceAll = function(target, search, replacement) {
  return target.replace(new RegExp(search, 'g'), replacement)
}



// WEBPACK FOOTER //
// ./scripts/invite-friend/invite-friend.ctrl.js